<template>
  <div class="form-group">
    <label for="distanceRangeInput">Im Umkreis von</label>
    <label for="distanceRangeInput">{{ rangeValue }}</label>
    <vue-slider
      ref="vue-slider"
      tooltip="false"
      :min="1"
      :max="rangeEnd"
      step="1"
      id="distanceRangeInput"
      :value="rangeValue"
      @input="setValue"
      :data="distances"
    ></vue-slider>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      required: true
    }
  },
  data() {
    return {
      distances: [
        "10 km",
        "20 km",
        "30 km",
        "40 km",
        "50 km",
        "75 km",
        "100 km",
        "125 km",
        "150 km",
        "175 km",
        "200 km",
        "250 km",
        "300 km",
        "400 km"
      ],
      rangeValue: this.value + " km",
      started: false
    };
  },
  computed: {
    rangeEnd() {
      return this.distances.length;
    }
  },
  methods: {
    setValue(event) {
      if (this.$store.getters["user/auth"]) {
        this.rangeValue = event;
      } else {
        this.$refs["vue-slider"].currentValue = this.distances.indexOf(
          this.rangeValue
        );

        // Prevent showing modal on component create
        if (this.started) {
          this.$store.dispatch("publicProfileModal/show", this.$modal);
        } else {
          this.started = true;
        }
      }
    }
  },
  watch: {
    rangeValue() {
      this.$emit("input", parseInt(this.rangeValue));
    }
  }
};
</script>
